import React from "react";

type Props = {
  className?: string;
  placeholder?: string;
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  name?: string;
  id?: string;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  autoComplete?: string;
  maxLength?: number;
  minLength?: number;
  pattern?: string;
  title?: string;
  readOnly?: boolean;
  size?: number;
  step?: number;
  list?: string;
  form?: string;
  style?: React.CSSProperties;
  checked?: boolean;
};

const Input = ({
  className,
  placeholder,
  value,
  onChange,
  type,
  name,
  id,
  required,
  disabled,
  autoFocus,
  autoComplete,
  maxLength,
  minLength,
  pattern,
  title,
  readOnly,
  size,
  step,
  list,
  form,
  checked,
  style,
}: Props) => {
  return (
    <input
      className={`
        bg-white border border-gray-300 rounded-2xl py-2 px-3 h-10
        ${className}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      type={type}
      name={name}
      id={id}
      required={required}
      disabled={disabled}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
      maxLength={maxLength}
      minLength={minLength}
      pattern={pattern}
      title={title}
      readOnly={readOnly}
      size={size}
      step={step}
      list={list}
      form={form}
      style={style}
      checked={checked}
    />
  );
};

export default Input;
